enum placeholderPatterns {
    CPF = '000.000.000-00',
    CNPJ = 'AA.AAA.AAA/AAAA-00',
    CEP = '00000-000',
    PHONE = '(00) 00000-0000',
    NUMBER = '00000000000',
    SAP_S4 = 'Insira o código SAP',
    SAP_ECC = '000000',
    TMS = '0000000000',
    EMAIL = 'example@domain.com',
    DECIMAL_SMALL = '00',
    ID_EGATES = '0000',
}

export default placeholderPatterns;
